/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_Drop_OutInputs */



/**
* | output |
* | --- |
* | "Cannot drop out in this state" |
*
* @param {Err_Tournament_Cannot_Drop_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_drop_out = /** @type {((inputs?: Err_Tournament_Cannot_Drop_OutInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_Drop_OutInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'abandonner dans cet état")
	if (locale === "es") return /** @type {LocalizedString} */ ("No es posible retirarse en este estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível desistir neste estado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile abbandonare in questo stato")
	return /** @type {LocalizedString} */ ("Cannot drop out in this state")
});